import React,{useEffect} from "react";
import Nav from "../components/main/nav";
import { Link } from "react-router-dom";
const Terminos = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Nav />
      <div className="container mt-5 pt-5" id="section">
        <div className="row mt-4   ">
          <div className="col-md-12">
            <h4>Términos y condiciones</h4>
          </div>

          <div className="col-md-3 col-sm-12 col-xs-12 mt-4">
            <ul class="list-group">
              <li class="list-group-item">
                {" "}
                <Link
                  to="/politicas"
                  style={{
                    color: "black",
                  }}
                >
                  Política tratamiento de datos
                </Link>
              </li>
              <li
                class="list-group-item"
                style={{
                  backgroundColor: "rgb(2, 66, 121)",
                  color: "#fff",
                }}
              >
                <Link
                  to="/terminos"
                  style={{
                    color: "#fff",
                  }}
                >
                  Términos y condiciones
                </Link>
              </li>
            </ul>
          </div>

          <div className="col mt-4 card">
            <p class="text-justify">
              
            </p>
          </div>
        </div>
      </div>
      <footer class="footer">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-6 footer-content">
              <div class="footer-colm-1">
                <h3 class="footer-logo">INNODE</h3>
                <p>
                  Empresa líder en calidad de servicio con cobertura nacional{" "}
                </p>
              </div>
            </div>
            <div class="col-lg-2 col-md-6 footer-content">
              <div class="footer-colm-2">
                <h5 class="footer-colm-title">Nosotros</h5>
                <ul class="footer-nav">
                  <li>
                  {/* eslint-disable-next-line */}
                    <a href="#">Quiénes somos</a>
                  </li>
                  <li>
                    {/* eslint-disable-next-line */}
                    <a href="#">Contáctenos</a>
                  </li>
                  <li>
                    {/* eslint-disable-next-line */}
                    <a href="#"></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-2 col-md-6 footer-content">
              <div class="footer-colm-3">
                <h5 class="footer-colm-title">Soporte</h5>
                <ul class="footer-nav">
                  <li>
                    <Link to="/terminos">Términos y condiciones</Link>
                  </li>
                  <li>
                    <Link to="/politicas">Política tratamiento de datos</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 footer-content">
              <div class="footer-colm-4 footer-subscribe">
                <h5 class="footer-colm-title">Información de contacto</h5>

                <p>
                  <a href="mailto:contactenos@orocash.com">
                    contactenos@orocash.com
                  </a>
                </p>
                <p>
                  <a href="tel:+5930994480427">+5930994480427</a>
                </p>
              </div>
            </div>
          </div>
          <div class="border-shadow-2"></div>
          <div class="row">
            <div class="col-md-12">
              <div class="copyright-text text-center">
                <p>SIAPE © {new Date().getFullYear()}</p>
                <p>
                  {/* eslint-disable-next-line */}
                  Designed by <a href="#">Innode.</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terminos;
